<template>
  <div>
    <div class="f-inline-group">
      <legend
        :class="{ 'f-field__label--required' : isRequired }"
        class="f-field__label"
      >
        {{ $t(`fields.record.${fieldName}.label`) }}
      </legend>
      <div
        v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
        class="f-field__tooltip"
      >
        <Tooltip>
          <p>
            {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
          </p>
        </Tooltip>
      </div>
    </div>
    <div class="f-field">
      <div class="f-inline-group">
        <div class="f-field-advanced-search__controller-select">
          <select
            v-model="modelValue.option"
            class="f-field__input f-field__input--select"
            @change="$emit('change', modelValue)"
          >
            <option
              v-for="opt in ['all', 'any', 'none']"
              :key="fieldName + opt"
              :value="opt"
            >
              {{ $t(`advancedsearch.fields.string.options.${opt}`) }}
            </option>
          </select>
        </div>
        <TextInputField
          v-model="modelValue.value"
          :field-name="`record.${fieldName}`"
          :placeholder="placeholder"
          :is-required="isRequired"
          :show-label="false"
          :error="error"
          :input-mode="inputMode"
          @input="validate"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TextInputField from '#src/components/utils/fields/TextInputField.vue'
import Tooltip from '#src/components/utils/Tooltip.vue'
import { MetadataUtils } from '@scholar/metadata-utils/main'

export default {
  components: {
    TextInputField,
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    hideTooltip: {
      type: Boolean,
      default: false
    },
    inputMode: {
      type: String,
      default: 'text'
    }
  },
  emits: ['change', 'input', 'update:modelValue'],
  data() {
    return {
      validation: { status: true },
      parser: new MetadataUtils().getParserByType(this.recordType)
    }
  },
  computed: {
    error() {
      return this.validation.status ? {} : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.field?.error}`) }
    },
    placeholder() {
      if (this.$te(`advancedsearch.fields.${this.fieldName}.placeholder`)) {
        return this.$t(`advancedsearch.fields.${this.fieldName}.placeholder`)
      } else {
        return this.$t(`fields.record.${this.fieldName}.placeholder`)
      }
    }
  },
  async created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = ''
    }
    if (this.modelValue.option === null) {
      this.modelValue.option = 'all'
    }
  },
  methods: {
    async validate(val) {
      if (!this.isRequired && val === '') {
        this.validation = { status: true }
      } else if (this.validatorName.startsWith('fundingReferences')) {
      // HACK: These fields do not have individual validators. Maybe create a getFieldValidatorName?
      // Would not work for keywords as no validator is general
        this.validation = await this.parser.validateByField('title', val)
      } else {
        this.validation = await this.parser.validateByField(this.validatorName || this.fieldName, val)
      }
      this.modelValue.isValid = this.validation.status

      this.$emit('input', this.modelValue)
      this.$emit('update:modelValue', this.modelValue)
    }
  }
}
</script>
